const vidris_sequential = {
  version: 1,
  themeName: 'Vidris Sequential',
  theme: {
    seriesCnt: '10',
    backgroundColor: 'rgba(0,0,0,0)',
    titleColor: '#182027',
    subtitleColor: '#2b3947',
    textColorShow: false,
    textColor: '#2b3947',
    markTextColor: '#fefefe',
    markLineColor: '#1891f6',
    color: [
      '#fde724',
      '#f9c741',
      '#ffa601',
      '#ff7a43',
      '#f95d6a',
      '#d35087',
      '#a05094',
      '#665191',
      '#2e4a7d',
      '#003e5d',
    ],
    borderColor: '#ccc',
    borderWidth: '0',
    visualMapColor: ['#ff7a43', '#ffa601', '#fde724'],
    legendTextColor: '#b3b3b3',
    kColor: '#e8a530',
    kColor0: '#73b234',
    kBorderColor: '#e8a530',
    kBorderColor0: '#73b234',
    kBorderWidth: 1,
    lineWidth: '2',
    symbolSize: '0',
    symbol: 'emptyCircle',
    symbolBorderWidth: '0',
    lineSmooth: true,
    graphLineWidth: '1',
    graphLineColor: '#eaeaed',
    mapLabelColor: '#000',
    mapLabelColorE: 'rgb(100,0,0)',
    mapBorderColor: '#444',
    mapBorderColorE: '#444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eee',
    mapAreaColorE: 'rgba(255,215,0,0.8)',
    axes: [
      {
        type: 'all',
        name: '通用坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'category',
        name: '类目坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#f5f6fa',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: false,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'value',
        name: '数值坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#eaeaed',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: true,
        splitLineColor: ['#eaeaed'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'log',
        name: '对数坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'time',
        name: '时间坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
    ],
    axisSeperateSetting: true,
    toolboxColor: '#999999',
    toolboxEmpasisColor: '#666666',
    tooltipAxisColor: '#cccccc',
    tooltipAxisWidth: 1,
    timelineLineColor: '#2b3947',
    timelineLineWidth: '0.5',
    timelineItemColor: '#293c55',
    timelineItemColorE: '#019ad5',
    timelineCheckColor: '#019ad5',
    timelineCheckBorderColor: '#182027',
    timelineItemBorderWidth: '0.5',
    timelineControlColor: '#2b3947',
    timelineControlBorderColor: '#2b3947',
    timelineControlBorderWidth: '0.3',
    timelineLabelColor: '#2b3947',
    datazoomBackgroundColor: 'rgba(47,69,84,0)',
    datazoomDataColor: 'rgba(47,69,84,0.3)',
    datazoomFillColor: 'rgba(167,183,204,0.4)',
    datazoomHandleColor: '#a7b7cc',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#333333',
  },
};

const magma_sequential = {
  version: 1,
  themeName: 'Magma Sequential',
  theme: {
    seriesCnt: '10',
    backgroundColor: 'rgba(0,0,0,0)',
    titleColor: '#182027',
    subtitleColor: '#2b3947',
    textColorShow: false,
    textColor: '#2b3947',
    markTextColor: '#fefefe',
    markLineColor: '#1891f6',
    color: [
      '#440b53',
      '#472577',
      '#404787',
      '#34638d',
      '#218a8d',
      '#27ae7e',
      '#54c667',
      '#b7dd2a',
      '#dce319',
      '#fde724',
    ],
    borderColor: '#ccc',
    borderWidth: '0',
    visualMapColor: ['#34638d', '#218a8d', '#27ae7e'],
    legendTextColor: '#b3b3b3',
    kColor: '#27ae7e',
    kColor0: '#472577',
    kBorderColor: '#27ae7e',
    kBorderColor0: '#472577',
    kBorderWidth: 1,
    lineWidth: '2',
    symbolSize: '0',
    symbol: 'emptyCircle',
    symbolBorderWidth: '0',
    lineSmooth: true,
    graphLineWidth: '1',
    graphLineColor: '#eaeaed',
    mapLabelColor: '#000',
    mapLabelColorE: 'rgb(100,0,0)',
    mapBorderColor: '#444',
    mapBorderColorE: '#444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eee',
    mapAreaColorE: 'rgba(255,215,0,0.8)',
    axes: [
      {
        type: 'all',
        name: '通用坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'category',
        name: '类目坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#f5f6fa',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: false,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'value',
        name: '数值坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#eaeaed',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: true,
        splitLineColor: ['#eaeaed'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'log',
        name: '对数坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'time',
        name: '时间坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
    ],
    axisSeperateSetting: true,
    toolboxColor: '#999999',
    toolboxEmpasisColor: '#666666',
    tooltipAxisColor: '#cccccc',
    tooltipAxisWidth: 1,
    timelineLineColor: '#2b3947',
    timelineLineWidth: '0.5',
    timelineItemColor: '#293c55',
    timelineItemColorE: '#019ad5',
    timelineCheckColor: '#019ad5',
    timelineCheckBorderColor: '#182027',
    timelineItemBorderWidth: '0.5',
    timelineControlColor: '#2b3947',
    timelineControlBorderColor: '#2b3947',
    timelineControlBorderWidth: '0.3',
    timelineLabelColor: '#2b3947',
    datazoomBackgroundColor: 'rgba(47,69,84,0)',
    datazoomDataColor: 'rgba(47,69,84,0.3)',
    datazoomFillColor: 'rgba(167,183,204,0.4)',
    datazoomHandleColor: '#a7b7cc',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#333333',
  },
};

const carrier_divergent = {
  version: 1,
  themeName: 'Carrier Divergent',
  theme: {
    seriesCnt: '9',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    titleColor: '#333',
    subtitleColor: '#aaa',
    textColorShow: false,
    textColor: '#333',
    markTextColor: '#eee',
    markLineColor: '#1891f6',
    color: ['#152c73', '#807fb7', '#8cb9fb', '#1891f6', '#d3e2ff', '#bac0d0', '#92a9be', '#617080'],
    borderColor: '#ccc',
    borderWidth: 0,
    visualMapColor: ['#152c73', '#1891f6', '#d3e2ff'],
    legendTextColor: '#333',
    kColor: '#152c73',
    kColor0: '#807fb7',
    kBorderColor: '#1891f6',
    kBorderColor0: '#807fb7',
    kBorderWidth: 1,
    lineWidth: 2,
    symbolSize: 4,
    symbol: 'emptyCircle',
    symbolBorderWidth: 1,
    lineSmooth: false,
    graphLineWidth: 1,
    graphLineColor: '#aaa',
    mapLabelColor: '#000',
    mapLabelColorE: '#f1f1f1',
    mapBorderColor: '#bac0d0',
    mapBorderColorE: '#444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eee',
    mapAreaColorE: '#152c73',
    axes: [
      {
        type: 'all',
        name: '通用坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'category',
        name: '类目坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: false,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'value',
        name: '数值坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'log',
        name: '对数坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'time',
        name: '时间坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
    ],
    axisSeperateSetting: true,
    toolboxColor: '#999',
    toolboxEmpasisColor: '#666',
    tooltipAxisColor: '#ccc',
    tooltipAxisWidth: 1,
    timelineLineColor: '#293c55',
    timelineLineWidth: 1,
    timelineItemColor: '#152c73',
    timelineItemColorE: '#1891f6',
    timelineCheckColor: '#d3e2ff',
    timelineCheckBorderColor: '#92a9be',
    timelineItemBorderWidth: 1,
    timelineControlColor: '#293c55',
    timelineControlBorderColor: '#293c55',
    timelineControlBorderWidth: 0.5,
    timelineLabelColor: '#293c55',
    datazoomBackgroundColor: 'rgba(47,69,84,0)',
    datazoomDataColor: 'rgba(47,69,84,0.3)',
    datazoomFillColor: 'rgba(167,183,204,0.4)',
    datazoomHandleColor: '#a7b7cc',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#333',
  },
};

const carrier_qualitative = {
  version: 1,
  themeName: 'Carrier Qualitative',
  theme: {
    seriesCnt: '9',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    titleColor: '#333',
    subtitleColor: '#aaa',
    textColorShow: false,
    textColor: '#333',
    markTextColor: '#eee',
    markLineColor: '#1891f6',
    color: [
      '#152c73',
      '#555792',
      '#8987b1',
      '#bcbbd1',
      '#f1f1f1',
      '#cbd7f3',
      '#a3bff4',
      '#72a7f5',
      '#1891f6',
    ],
    borderColor: '#ccc',
    borderWidth: 0,
    visualMapColor: ['#152c73', '#1891f6', '#d3e2ff'],
    legendTextColor: '#333',
    kColor: '#152c73',
    kColor0: '#807fb7',
    kBorderColor: '#1891f6',
    kBorderColor0: '#807fb7',
    kBorderWidth: 1,
    lineWidth: 2,
    symbolSize: 4,
    symbol: 'emptyCircle',
    symbolBorderWidth: 1,
    lineSmooth: false,
    graphLineWidth: 1,
    graphLineColor: '#aaa',
    mapLabelColor: '#000',
    mapLabelColorE: '#f1f1f1',
    mapBorderColor: '#bac0d0',
    mapBorderColorE: '#444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eee',
    mapAreaColorE: '#152c73',
    axes: [
      {
        type: 'all',
        name: '通用坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'category',
        name: '类目坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: false,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'value',
        name: '数值坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'log',
        name: '对数坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'time',
        name: '时间坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
    ],
    axisSeperateSetting: true,
    toolboxColor: '#999',
    toolboxEmpasisColor: '#666',
    tooltipAxisColor: '#ccc',
    tooltipAxisWidth: 1,
    timelineLineColor: '#293c55',
    timelineLineWidth: 1,
    timelineItemColor: '#152c73',
    timelineItemColorE: '#1891f6',
    timelineCheckColor: '#d3e2ff',
    timelineCheckBorderColor: '#92a9be',
    timelineItemBorderWidth: 1,
    timelineControlColor: '#293c55',
    timelineControlBorderColor: '#293c55',
    timelineControlBorderWidth: 0.5,
    timelineLabelColor: '#293c55',
    datazoomBackgroundColor: 'rgba(47,69,84,0)',
    datazoomDataColor: 'rgba(47,69,84,0.3)',
    datazoomFillColor: 'rgba(167,183,204,0.4)',
    datazoomHandleColor: '#a7b7cc',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#333',
  },
};

const forest_sequential = {
  version: 1,
  themeName: 'Forest Sequential',
  theme: {
    seriesCnt: '10',
    backgroundColor: 'rgba(0,0,0,0)',
    titleColor: '#182027',
    subtitleColor: '#2b3947',
    textColorShow: false,
    textColor: '#2b3947',
    markTextColor: '#8c8246',
    markLineColor: '#1891f6',
    color: [
      '#093e3e',
      '#175a44',
      '#27784b',
      '#4ba657',
      '#78c364',
      '#8ed06b',
      '#c4ea99',
      '#e1f4bd',
      '#ffffe0',
      '#00313a',
    ],
    borderColor: '#ccc',
    borderWidth: '0',
    visualMapColor: ['#175a44', '#4ba657', '#8ed06b'],
    legendTextColor: '#b3b3b3',
    kColor: '#8ed06b',
    kColor0: '#175a44',
    kBorderColor: '#78c364',
    kBorderColor0: '#00313a',
    kBorderWidth: 1,
    lineWidth: '2',
    symbolSize: '0',
    symbol: 'emptyCircle',
    symbolBorderWidth: '0',
    lineSmooth: true,
    graphLineWidth: '1',
    graphLineColor: '#eaeaed',
    mapLabelColor: '#000',
    mapLabelColorE: 'rgb(100,0,0)',
    mapBorderColor: '#444',
    mapBorderColorE: '#444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eee',
    mapAreaColorE: 'rgba(255,215,0,0.8)',
    axes: [
      {
        type: 'all',
        name: '通用坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'category',
        name: '类目坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#f5f6fa',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: false,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'value',
        name: '数值坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#eaeaed',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: true,
        splitLineColor: ['#eaeaed'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'log',
        name: '对数坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'time',
        name: '时间坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
    ],
    axisSeperateSetting: true,
    toolboxColor: '#999999',
    toolboxEmpasisColor: '#666666',
    tooltipAxisColor: '#cccccc',
    tooltipAxisWidth: 1,
    timelineLineColor: '#2b3947',
    timelineLineWidth: '0.5',
    timelineItemColor: '#293c55',
    timelineItemColorE: '#019ad5',
    timelineCheckColor: '#019ad5',
    timelineCheckBorderColor: 'rgba(24,32,39,1)',
    timelineItemBorderWidth: '0.5',
    timelineControlColor: '#2b3947',
    timelineControlBorderColor: '#2b3947',
    timelineControlBorderWidth: '0.3',
    timelineLabelColor: '#2b3947',
    datazoomBackgroundColor: 'rgba(47,69,84,0)',
    datazoomDataColor: 'rgba(47,69,84,0.3)',
    datazoomFillColor: 'rgba(167,183,204,0.4)',
    datazoomHandleColor: '#a7b7cc',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#333333',
  },
};

const cerulean_sequential = {
  version: 1,
  themeName: 'Cerulean Sequential',
  theme: {
    seriesCnt: '10',
    backgroundColor: 'rgba(0,0,0,0)',
    titleColor: '#182027',
    subtitleColor: '#2b3947',
    textColorShow: false,
    textColor: '#2b3947',
    markTextColor: '#8c8246',
    markLineColor: '#1891f6',
    color: [
      '#190054',
      '#1B286D',
      '#1E4B81',
      '#246D96',
      '#3091AA',
      '#57B4B9',
      '#86D4CA',
      '#A7E3D7',
      '#C9F0E3',
      '#EAFFF0',
    ],
    borderColor: '#ccc',
    borderWidth: '0',
    visualMapColor: ['#175a44', '#4ba657', '#8ed06b'],
    legendTextColor: '#b3b3b3',
    kColor: '#8ed06b',
    kColor0: '#175a44',
    kBorderColor: '#78c364',
    kBorderColor0: '#00313a',
    kBorderWidth: 1,
    lineWidth: '2',
    symbolSize: '0',
    symbol: 'emptyCircle',
    symbolBorderWidth: '0',
    lineSmooth: true,
    graphLineWidth: '1',
    graphLineColor: '#eaeaed',
    mapLabelColor: '#000',
    mapLabelColorE: 'rgb(100,0,0)',
    mapBorderColor: '#444',
    mapBorderColorE: '#444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eee',
    mapAreaColorE: 'rgba(255,215,0,0.8)',
    axes: [
      {
        type: 'all',
        name: '通用坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'category',
        name: '类目坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#f5f6fa',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: false,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'value',
        name: '数值坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#eaeaed',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: true,
        splitLineColor: ['#eaeaed'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'log',
        name: '对数坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'time',
        name: '时间坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
    ],
    axisSeperateSetting: true,
    toolboxColor: '#999999',
    toolboxEmpasisColor: '#666666',
    tooltipAxisColor: '#cccccc',
    tooltipAxisWidth: 1,
    timelineLineColor: '#2b3947',
    timelineLineWidth: '0.5',
    timelineItemColor: '#293c55',
    timelineItemColorE: '#019ad5',
    timelineCheckColor: '#019ad5',
    timelineCheckBorderColor: 'rgba(24,32,39,1)',
    timelineItemBorderWidth: '0.5',
    timelineControlColor: '#2b3947',
    timelineControlBorderColor: '#2b3947',
    timelineControlBorderWidth: '0.3',
    timelineLabelColor: '#2b3947',
    datazoomBackgroundColor: 'rgba(47,69,84,0)',
    datazoomDataColor: 'rgba(47,69,84,0.3)',
    datazoomFillColor: 'rgba(167,183,204,0.4)',
    datazoomHandleColor: '#a7b7cc',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#333333',
  },
};

const minty_inferno = {
  version: 1,
  themeName: 'Minty / Inferno',
  theme: {
    seriesCnt: '11',
    backgroundColor: 'rgba(0,0,0,0)',
    titleColor: '#182027',
    subtitleColor: '#2b3947',
    textColorShow: false,
    textColor: '#2b3947',
    markTextColor: '#fefefe',
    markLineColor: '#1891f6',
    color: [
      '#28AE7E',
      '#5EBD94',
      '#87CAAA',
      '#AAD7C1',
      '#CDE3D9',
      '#F0F0F0',
      '#F3CECD',
      '#F3ADAD',
      '#F08A8B',
      '#E9676D',
      '#E03A50',
    ],
    borderColor: '#ccc',
    borderWidth: '0',
    visualMapColor: ['#F08A8B', '#F3ADAD', '#F3CECD'],
    legendTextColor: '#b3b3b3',
    kColor: '#5EBD94',
    kColor0: '#E9676D',
    kBorderColor: '#28AE7E',
    kBorderColor0: '#E03A50',
    kBorderWidth: 1,
    lineWidth: '2',
    symbolSize: '0',
    symbol: 'emptyCircle',
    symbolBorderWidth: '0',
    lineSmooth: true,
    graphLineWidth: '1',
    graphLineColor: '#eaeaed',
    mapLabelColor: '#000',
    mapLabelColorE: 'rgb(100,0,0)',
    mapBorderColor: '#444',
    mapBorderColorE: '#444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eee',
    mapAreaColorE: 'rgba(255,215,0,0.8)',
    axes: [
      {
        type: 'all',
        name: '通用坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'category',
        name: '类目坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#f5f6fa',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: false,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'value',
        name: '数值坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#eaeaed',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: true,
        splitLineColor: ['#eaeaed'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'log',
        name: '对数坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'time',
        name: '时间坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
    ],
    axisSeperateSetting: true,
    toolboxColor: '#999999',
    toolboxEmpasisColor: '#666666',
    tooltipAxisColor: '#cccccc',
    tooltipAxisWidth: 1,
    timelineLineColor: '#2b3947',
    timelineLineWidth: '0.5',
    timelineItemColor: '#293c55',
    timelineItemColorE: '#019ad5',
    timelineCheckColor: '#019ad5',
    timelineCheckBorderColor: '#182027',
    timelineItemBorderWidth: '0.5',
    timelineControlColor: '#2b3947',
    timelineControlBorderColor: '#2b3947',
    timelineControlBorderWidth: '0.3',
    timelineLabelColor: '#2b3947',
    datazoomBackgroundColor: 'rgba(47,69,84,0)',
    datazoomDataColor: 'rgba(47,69,84,0.3)',
    datazoomFillColor: 'rgba(167,183,204,0.4)',
    datazoomHandleColor: '#a7b7cc',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#333333',
  },
};
const kobai_divergent = {
  version: 1,
  themeName: 'Kobai divergent',
  theme: {
    seriesCnt: '11',
    backgroundColor: 'rgba(0,0,0,0)',
    titleColor: '#182027',
    subtitleColor: '#2b3947',
    textColorShow: false,
    textColor: '#2b3947',
    markTextColor: '#fefefe',
    markLineColor: '#1891f6',
    color: [
      '#134B6D',
      '#3187BD',
      '#6EA6B6',
      '#9BC4B3',
      '#CAE3B4',
      '#FFFFBE',
      '#F6C186',
      '#DA8763',
      '#B9504A',
      '#93003A',
      '#66032A',
    ],
    borderColor: '#ccc',
    borderWidth: '0',
    visualMapColor: ['#3187BD', '#6EA6B6', '#9BC4B3'],
    legendTextColor: '#b3b3b3',
    kColor: '#3187BD',
    kColor0: '#93003A',
    kBorderColor: '#134B6D',
    kBorderColor0: '#66032A',
    kBorderWidth: 1,
    lineWidth: '2',
    symbolSize: '0',
    symbol: 'emptyCircle',
    symbolBorderWidth: '0',
    lineSmooth: true,
    graphLineWidth: '1',
    graphLineColor: '#eaeaed',
    mapLabelColor: '#000',
    mapLabelColorE: 'rgb(100,0,0)',
    mapBorderColor: '#444',
    mapBorderColorE: '#444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eee',
    mapAreaColorE: 'rgba(255,215,0,0.8)',
    axes: [
      {
        type: 'all',
        name: '通用坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'category',
        name: '类目坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#f5f6fa',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: false,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'value',
        name: '数值坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#eaeaed',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: true,
        splitLineColor: ['#eaeaed'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'log',
        name: '对数坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'time',
        name: '时间坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
    ],
    axisSeperateSetting: true,
    toolboxColor: '#999999',
    toolboxEmpasisColor: '#666666',
    tooltipAxisColor: '#cccccc',
    tooltipAxisWidth: 1,
    timelineLineColor: '#2b3947',
    timelineLineWidth: '0.5',
    timelineItemColor: '#293c55',
    timelineItemColorE: '#019ad5',
    timelineCheckColor: '#019ad5',
    timelineCheckBorderColor: '#182027',
    timelineItemBorderWidth: '0.5',
    timelineControlColor: '#2b3947',
    timelineControlBorderColor: '#2b3947',
    timelineControlBorderWidth: '0.3',
    timelineLabelColor: '#2b3947',
    datazoomBackgroundColor: 'rgba(47,69,84,0)',
    datazoomDataColor: 'rgba(47,69,84,0.3)',
    datazoomFillColor: 'rgba(167,183,204,0.4)',
    datazoomHandleColor: '#a7b7cc',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#333333',
  },
};

const kobai_categorical = {
  version: 1,
  themeName: 'Kobai categorical',
  theme: {
    seriesCnt: '16',
    backgroundColor: 'rgba(0,0,0,0)',
    titleColor: '#182027',
    subtitleColor: '#2b3947',
    textColorShow: false,
    textColor: '#2b3947',
    markTextColor: '#fefefe',
    markLineColor: '#1891f6',
    color: [
      '#E3A4D1',
      '#CCB4E3',
      '#472577',
      '#34638D',
      '#83C4DA',
      '#3187BD',
      '#218A8D',
      '#54C667',
      '#A1E3A7',
      '#B7DD28',
      '#DEED8A',
      '#FDE724',
      '#F9C741',
      '#FF7A43',
      '#D35087',
      '#A05094',
    ],
    borderColor: '#ccc',
    borderWidth: '0',
    visualMapColor: ['#3187BD', '#6EA6B6', '#9BC4B3'],
    legendTextColor: '#b3b3b3',
    kColor: '#3187BD',
    kColor0: '#93003A',
    kBorderColor: '#134B6D',
    kBorderColor0: '#66032A',
    kBorderWidth: 1,
    lineWidth: '2',
    symbolSize: '0',
    symbol: 'emptyCircle',
    symbolBorderWidth: '0',
    lineSmooth: true,
    graphLineWidth: '1',
    graphLineColor: '#eaeaed',
    mapLabelColor: '#000',
    mapLabelColorE: 'rgb(100,0,0)',
    mapBorderColor: '#444',
    mapBorderColorE: '#444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eee',
    mapAreaColorE: 'rgba(255,215,0,0.8)',
    axes: [
      {
        type: 'all',
        name: '通用坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'category',
        name: '类目坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#f5f6fa',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: false,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'value',
        name: '数值坐标轴',
        axisLineShow: true,
        axisLineColor: '#b3b3b3',
        axisTickShow: true,
        axisTickColor: '#eaeaed',
        axisLabelShow: true,
        axisLabelColor: '#2b3947',
        splitLineShow: true,
        splitLineColor: ['#eaeaed'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'log',
        name: '对数坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
      {
        type: 'time',
        name: '时间坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
      },
    ],
    axisSeperateSetting: true,
    toolboxColor: '#999999',
    toolboxEmpasisColor: '#666666',
    tooltipAxisColor: '#cccccc',
    tooltipAxisWidth: 1,
    timelineLineColor: '#2b3947',
    timelineLineWidth: '0.5',
    timelineItemColor: '#293c55',
    timelineItemColorE: '#019ad5',
    timelineCheckColor: '#019ad5',
    timelineCheckBorderColor: '#182027',
    timelineItemBorderWidth: '0.5',
    timelineControlColor: '#2b3947',
    timelineControlBorderColor: '#2b3947',
    timelineControlBorderWidth: '0.3',
    timelineLabelColor: '#2b3947',
    datazoomBackgroundColor: 'rgba(47,69,84,0)',
    datazoomDataColor: 'rgba(47,69,84,0.3)',
    datazoomFillColor: 'rgba(167,183,204,0.4)',
    datazoomHandleColor: '#a7b7cc',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#333333',
  },
};

// If this name changes, charts might break; caution changing name
export const KobaiDefaultThemeName = 'Kobai divergent';

const Themes = {
  'Cerulean sequential': cerulean_sequential,
  'Forest sequential': forest_sequential,
  'Magma sequential': magma_sequential,
  'Minty inferno': minty_inferno,
  [KobaiDefaultThemeName]: kobai_divergent,
  'Kobai categorical': kobai_categorical,
  'Vidris sequential': vidris_sequential,
  qualitative: carrier_qualitative,
  divergent: carrier_divergent,
};

// set default theme to KobaiDefaultThemeName; if it doesn't exist, return first entry
export const KobaiDefaultTheme =
  KobaiDefaultThemeName in Themes ? KobaiDefaultThemeName : Object.keys(Themes)[0];

export default Themes;
